import AttachmentIcon from './AttachmentIcon';

export default AttachmentIcon;
